// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__MS5Nd","detailsBorder":"styles_detailsBorder__1_INM"};